import React, { useState } from 'react';

import './styles.css';
import NumberSpinner from '../NumberSpinner';

type Props = {
  value: number;
  callback: any;
};

const Throwaway = ({
  value,
  callback,
}: Props) => {
  const [total, setTotal] = useState<number>(0);

  function changeValue(value: number) {
    setTotal(value);
    callback(value);
  }

  return (
    <div className={'score-value'}>
      <div className={'value'}>{value}</div>
      <NumberSpinner
        min={0}
        max={8}
        value={total}
        onChange={changeValue}
      />
    </div>
  );
};

export default Throwaway;